import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import { Button } from "@recobra/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@recobra/ui/tooltip";

export const TaskCompletionButton: FC<{
  disabled: boolean;
  disabledReason?: string;
  form?: string;
}> = ({ disabled, disabledReason, form }) => {
  const button = (
    <Button
      type="submit"
      form={form}
      disabled={disabled}
      className={disabledReason ? "pointer-events-none" : undefined}
    >
      {m.task_outcome_resolve()}
    </Button>
  );

  if (!disabledReason) return button;

  return (
    <Tooltip>
      <TooltipTrigger render={<span className="inline-flex cursor-not-allowed" tabIndex={0} />}>
        {button}
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        {disabledReason}
      </TooltipContent>
    </Tooltip>
  );
};
